<!-- @format -->

<template>
  <div>
    <div v-if="step >= 1 && currencies.length > 1" class="ui attached message">
      <strong>{{ currency }} based goal</strong>
    </div>
    <div class="ui padded attached message">
      <div class="content">
        <div class="header" v-if="step <= 1">New Goal</div>
        <div v-else>
          <h1 class="ui header" id="intro" ref="intro">
            <img
              class="ui image animated rotate-vert-center"
              :src="activePlan.goalTypePictureUrl"
            />
            <div class="content">
              {{ activePlan.goalInfo.goalName }}
              <br />
              <span class="ui sub header">
                <small>{{ activePlan.goalInfo.goalDescription }}</small>
              </span>
            </div>
          </h1>
        </div>
      </div>
    </div>
    <div
      :class="
        'ui attached very basic ' +
          (loading == true ? 'loading' : '') +
          'segment'
      "
    >
      <div class="ui very basic segment" v-if="step == 0">
        <div class="ui divided items">
          <div class="item">
            <div class="content">
              <a style="font-size: large" @click.prevent="showStep1('ZAR')">
                ZAR goal
              </a>

              <div class="meta">
                <span class="cinema"></span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="content">
              <a style="font-size: large" @click.prevent="showStep1('USD')">
                USD goal
              </a>

              <div class="meta">
                <span class="cinema"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui very basic segment" v-if="step == 1">
        <div
          class="ui divided items"
          v-for="(pl, index) in goalTypes"
          v-bind:key="pl.id"
        >
          <div class="item">
            <div
              :class="
                'ui mini image animated rotate-vert-center ' +
                  ('delay-' + (index + 1))
              "
            >
              <img :src="pl.goalTypePictureUrl" />
            </div>
            <div class="content">
              <a style="font-size: large" @click.prevent="showStep2(pl)">
                {{ pl.goalName }}
              </a>

              <div class="meta">
                <span class="cinema">{{ pl.goalDescription }}</span>
              </div>
            </div>
          </div>
          <div class="ui divider"></div>
        </div>

        <div
          class="ui buttons"
          v-if="
            (currencies.length == 1 && step > 1) ||
              (currencies.length > 1 && step > 0)
          "
        >
          <div
            class="ui button"
            @click.prevent="currencies.length == 1 ? (step = 1) : (step = 0)"
          >
            Back
          </div>
        </div>
      </div>
      <div class="ui very basic segment" v-if="step == 2">
        <div class="ui form">
          <div class="ui field">
            <label>Goal Description</label>
            <input v-model="activePlan.goalInfo.goalDescription" />
          </div>
        </div>
        <div class="ui divider"></div>
        <div class="ui buttons">
          <div class="ui button" @click.prevent="step = 1">Back Step</div>
          <div class="ui primary button" @click.prevent="step = 3">
            Next Step
          </div>
        </div>
      </div>
      <div class="ui very basic segment" v-if="step == 3">
        <div class="ui">
          <h2>Financial Needs Analysis</h2>
          <Emergency
            v-if="activePlan.goalTypeEnum == 'Emergency'"
            :activePlan="activePlan"
          />
          <PreRetirement
            v-if="activePlan.goalTypeEnum == 'PreRetirement'"
            :activePlan="activePlan"
          />
          <PostRetiremet
            v-if="activePlan.goalTypeEnum == 'PostRetirement'"
            :activePlan="activePlan"
          />
          <Education
            v-if="activePlan.goalTypeEnum == 'Education'"
            :activePlan="activePlan"
          />

          <GeneralInvesting
            v-if="activePlan.goalTypeEnum == 'GeneralInvesting'"
            :activePlan="activePlan"
          />
        </div>
        <div class="ui divider"></div>
        <div class="ui buttons">
          <div class="ui button" @click.prevent="step = 2">Back Step</div>
          <div class="ui primary button" @click.prevent="step = 4">
            Next Step
          </div>
        </div>
      </div>
      <div class="ui very basic segment" v-if="step == 4">
        <div class="ui">
          <RiskProfiler
            :currency="currency"
            :activePlan="activePlan"
            :riskStep="riskStep"
            v-on:changeRiskStep="changeRiskStep($event)"
            v-on:changePrimaryStep="changePrimaryStep($event)"
          />
        </div>
        <div
          class=""
          v-if="activePlan.goalRiskProfile && riskStep == 'goalRiskProfile'"
        >
          <div class="ui divider"></div>

          <div class="ui buttons">
            <div
              :class="
                'ui primary large ' + (loading ? 'loading' : '') + ' button'
              "
              @click.prevent="createPlan"
              @
            >
              Create Goal
            </div>
          </div>
          <div v-if="message != ''" class="ui message">
            <p>
              Sorry, something went wrong. The PortfolioLink team has been
              notified.
            </p>
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetProjection,
  GetIncomeCashFlowRequest,
  GetContributionCashFlowRequest,
  sendErrorEmail,
} from "@/dtos";

import Emergency from "@/components/NewGoalTypeEmergency";
import GeneralInvesting from "@/components/NewGoalTypeGeneralInvesting";
import Education from "@/components/NewGoalTypeEducation";
import PreRetirement from "@/components/NewGoalTypePreRetirement";
import PostRetiremet from "@/components/NewGoalTypePostRetirement";
import RiskProfiler from "@/components/NewGoalTypeRiskProfiler";
import * as _ from "lodash";
import numeral from "numeral";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import {
  getGoalTypes,
  saveProjection,
  getProjections,
  getIncomeCashFlowRequest,
  getContribution,
  getCustomPortfolio,
  getCustomPortfolios,
  getPartnerSettings,
} from "@/gateway.js";
export default {
  name: "GoalTypes",
  components: {
    Emergency,
    GeneralInvesting,
    Education,
    PreRetirement,
    PostRetiremet,
    RiskProfiler,
  },
  props: ["clientId"],
  data() {
    return {
      loading: false,
      currencies: [],
      message: "",
      currency: "ZAR",
      riskStep: "riskNeed",
      enableOffshore: true,
      step: -1,
      activePlan: null,
      riskProfiles: null,
      goalTypes: null,
    };
  },
  computed: {},
  methods: {
    async createPlan() {
      try {
        this.loading = true;
        let getIncomeCashFlowRequestR = new GetIncomeCashFlowRequest({
          income: this.activePlan.getIncomeCashFlowRequest.income,
          incomeGrowth: this.activePlan.getIncomeCashFlowRequest.incomeGrowth,
          incomeGrowthFrequency: this.activePlan.getIncomeCashFlowRequest
            .incomeGrowthFrequency,
          payoutFrequency: this.activePlan.getIncomeCashFlowRequest
            .payoutFrequency,
          incomeToLast: this.activePlan.getIncomeCashFlowRequest.incomeToLast,
          startYear: this.activePlan.getIncomeCashFlowRequest.startYear,
          currentAge: this.activePlan.getIncomeCashFlowRequest.currentAge,

          taxRate: this.activePlan.getIncomeCashFlowRequest.taxRate,
          hasAdhocCashFlow: this.activePlan.getIncomeCashFlowRequest
            .hasAdhocCashFlow,
          adhocCashFlowAge1: this.activePlan.getIncomeCashFlowRequest
            .adhocCashFlowAge1,
          adhocCashFlowAge2: this.activePlan.getIncomeCashFlowRequest
            .adhocCashFlowAge2,
          adhocCashFlowAge3: this.activePlan.getIncomeCashFlowRequest
            .adhocCashFlowAge3,
          adhocCashFlow1: this.activePlan.getIncomeCashFlowRequest
            .adhocCashFlow1,
          adhocCashFlow2: this.activePlan.getIncomeCashFlowRequest
            .adhocCashFlow2,
          adhocCashFlow3: this.activePlan.getIncomeCashFlowRequest
            .adhocCashFlow3,
        });

        var getContributionCashFlowRequestR = new GetContributionCashFlowRequest(
          {
            applyContribution: this.activePlan.getContributionCashFlowRequest
              .applyContribution,
            contribution: this.activePlan.getContributionCashFlowRequest
              .contribution,
            contributionFrequency: this.activePlan
              .getContributionCashFlowRequest.contributionFrequency,
            contributionGrowth:
              this.activePlan.getContributionCashFlowRequest
                .contributionGrowth / 100,
            contributionGrowthFrequency: this.activePlan
              .getContributionCashFlowRequest.contributionGrowthFrequency,
            contributionToLast: this.activePlan.getContributionCashFlowRequest
              .contributionToLast,
            contributionStartYear: this.activePlan
              .getContributionCashFlowRequest.contributionStartYear,
          }
        );
        // this.getIncomeCashFlowResponse = getIncome(this.getIncomeCashFlowRequest);

        let incomeResponse = await getIncomeCashFlowRequest(
          getIncomeCashFlowRequestR
        );
        let contriResponse = await getContribution(
          getContributionCashFlowRequestR
        );
        if (incomeResponse) {
          var getIncomeCashFlowResponseR = incomeResponse;
          if (contriResponse) {
            var getContributionCashFlowResponseR = contriResponse;
            this.activePlan.accounts[0].portfolios[0].portfolio = this.activePlan.goalRiskProfile.getGoalRiskProfileResponse.portfolio;
            // add performances & aa
            const cp = await getCustomPortfolio({
              currency: this.currency,
              id: this.activePlan.goalRiskProfile.getGoalRiskProfileResponse
                .portfolio.customPortfolioId,
              loadUnderlyingData: true,
            });
            let fullPortfolio = cp.portfolioView;
            this.activePlan.accounts[0].portfolios[0].portfolio = fullPortfolio;
            /* console.log(
            "this.activePlan.goalRiskProfile.getGoalRiskProfileResponse.portfolio",
            this.activePlan.goalRiskProfile.getGoalRiskProfileResponse.portfolio
          );
          console.log("fullportfolio", fullPortfolio);*/
            const partnerSettingsResponse = await getPartnerSettings();
            if (partnerSettingsResponse) {
              var projectionRequest = new GetProjection({
                currency: this.currency,
                accounts: this.activePlan.accounts,
                currentAge: this.activePlan.getIncomeCashFlowRequest.currentAge,
                incomeToLastUntilAge: this.activePlan.incomeToLast,
                getIncomeCashFlowRequest: this.activePlan
                  .getIncomeCashFlowRequest,
                getContributionCashFlowRequest: this.activePlan
                  .getContributionCashFlowRequest,
                riskProfile: this.activePlan.goalRiskProfile
                  .getGoalRiskProfileResponse.riskProfileObject,
                goalRiskProfile: this.activePlan.goalRiskProfile,
                incomeCashFlowResponse: getIncomeCashFlowResponseR,
                contributionCashFlowResponse: getContributionCashFlowResponseR,
                platformFee: this.activePlan.platformFee,
                otherCharges: this.activePlan.otherCharges,
                advisorFee: this.activePlan.advisorFee,
                managementFees: this.activePlan.managementFees,
                goalInfo: this.activePlan.goalInfo,
                isFundAlphaEqualToFees: this.activePlan.isFundAlphaEqualToFees,
                aaType: this.activePlan.aaType,
                moreLikelyZScore: this.activePlan.moreLikelyZScore,
                lessLikelyZScore: this.activePlan.lessLikelyZScore,
                showLowestProjectedOutcome: this.activePlan
                  .showLowestProjectedOutcome,
                appearanceSettings:
                  partnerSettingsResponse.partnerDefaultSettings
                    .appearanceSettings,
              });
              const presponse = await getProjections(projectionRequest);
              var projectionResponse = presponse;

              const response = await saveProjection({
                clientGoalV2Id: 0,
                clientId: this.clientId,
                requestObject: projectionRequest,
                responseObject: projectionResponse,
              });

              if (response) {
                this.loading = false;
                this.$router.push(
                  "/v2/client/" + this.clientId + "/goals/" + response.result
                );
              }
            }
          }
        }
      } catch (exception) {
        await sendErrorEmail({
          errorMessage: "Creating goal exception",
        });
        this.message = exception;
        this.loading = false;
      }
    },

    changeRiskStep(event) {
      this.riskStep = event.riskStep;
    },
    changePrimaryStep(event) {
      this.step = event.step;
    },
    async showStep1(currency) {
      this.currency = currency;
      const response2 = await getGoalTypes({
        clientId: this.clientId,
        currency: this.currency,
      });

      this.goalTypes = response2.result;
      this.step = 1;
    },
    showStep2(plan) {
      this.step = 2;
      this.activePlan = plan;
    },
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },

    async init() {
      this.loading = true;
      // const response = await getRiskProfiles();
      //  this.riskProfiles = response.result;
      // this.riskProfile = this.riskProfiles[0];
      var rc = await getCustomPortfolios({ currency: "All" });
      if (rc) {
        this.currencies = _.uniq(_.map(rc.result, "currency"));
        if (this.currencies.length == 1) {
          this.step = 1;
          this.enableOffshore = false;

          const response2 = await getGoalTypes({
            clientId: this.clientId,
            currency: this.currency,
          });
          this.goalTypes = response2.result;
        } else {
          this.step = 0;
        }
        this.loading = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
